import React from "react";
import { Empty as AntEmpty } from "antd";
import { EmptyProps as AntEmptyProps } from "antd/lib/empty";

export const Empty = (props: AntEmptyProps) => {
  return <AntEmpty {...props} image={AntEmpty.PRESENTED_IMAGE_SIMPLE} />;
};
